(function(){
    angular.module('tmx-app').factory('BusinessReportsService',['tmxResource',businessReportsService]);

    function businessReportsService(tmxResource){}
})();